// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2hvOh","content":"Consent_content__2A4qK","footer":"Consent_footer__trI-i"};